import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  // Non-fixed: rendered at top of layout, pushes content down instead of overlapping
  return (
    <div className="bg-destructive text-destructive-foreground text-center py-2 px-4 text-sm font-medium safe-area-top">
      <WifiOff className="inline h-3.5 w-3.5 mr-1.5 -mt-0.5" />
      Sin conexión — Algunas funciones no estarán disponibles
    </div>
  );
}
